import {assert} from 'assert-ts';
import {useAppSelector} from 'store/hooks';
import {selectMetadataEditSavedWorkSelector} from '../metadataEditSlice';
import type {WorkV4} from '../types';

export const useAssertSavedWork = (): WorkV4 => {
  const work = useAppSelector(selectMetadataEditSavedWorkSelector);
  return assert(work, 'useAssertSavedWork: no work');
};
